import React, { useState, useEffect, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import CardWrap from "../Common/CardWrap";
import { storeService } from "../../Services/store.service";
import { globalServices } from "../../Services/global.service";
import ResultModal from "../Common/ResultModal";
import SpinnerLoading from "../Common/SpinnerLoading";
import Tooltip from "../Common/Tooltip";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import Select from "react-select";
import { address, lettersOnly, numbersOnly, storeTag } from "../../Config/Regex";
import { roles } from "../../Config/Roles";
import { AuthContext } from "../../Contexts/AuthContext";

const StoreUpdate = (props) => {
  let id = props.match.params.storeId;
  const { locName, locStore } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { master, admin, support, owner } = roles;
  const { t: translator } = useTranslation();

  const [countries, setCountries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [postOffices, setPostOffices] = useState([]);
  const [store, setStore] = useState({
    storeId: id,
    tenantId: "",
    description: "",
    tag: "",
    type: "",
    footerNote: "",
    priceListId: "",
    street: "",
    streetNumber: "",
    streetNumberExtension: "",
    city: "",
    postalNumber: "",
    countryId: "",
    isActive: "",
  });

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  const goBack = () => {
    history.push(`/${locName}/${locStore != 0 ? locStore : ""}`);
  };

  const handleClose = () => {
    setModal({ show: false });
    if (modal.success === true) {
      goBack();
    }
  };

  useEffect(() => {
    if (![master, admin, support, owner].includes(Number(roleId)))
      history.push("/error-page/401");

    storeService
      .getById(id)
      .then((res) => {
        setStore(res.data);
        setIsLoading(false);
        setCity(res.data.city);
      })
      .catch((err) => console.log(err));

    globalServices
      .getCountries()
      .then((res) => setCountries(res.data))
      .catch((err) => console.log(err));

    globalServices
      .getPostOffices()
      .then((data) => {
        setPostOffices(data.data);
      })
      .catch(() => history.push("/Error"));
  }, []);

  const { register, handleSubmit, errors, control, formState } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: { store },
  });
  const history = useHistory();
  const [city, setCity] = useState();
  const getCity = (id, postal) => {
    globalServices
      .getCityByPostOffice(id)
      .then((res) => {
        document.getElementsByName("city")[0].value = res.data.data.name;
        setCity(res.data.data.name);
      })
      .catch(() => history.push("/Error"));
  };

  const onSubmit = (data) => {
    storeService
      .update({
        storeId: id,
        tenantId: Number(store.tenantId),
        description: data.description,
        tag: data.tag,
        type: Number(data.type),
        footerNote: data.footerNote,
        priceListId: data.priceListId,
        street: data.street,
        streetNumber: Number(data.streetNumber),
        streetNumberExtension: data.streetNumberExtension,
        city: data.city,
        postalNumber: data.postalNumber.value,
        countryId: data.countryId,
        isActive: data.isActive,
        useAccounting: Boolean(data.useAccounting),
        useFinancial: Boolean(data.useFinancial),
        //useAccounting: false,
      })
      .then((res) => {
        res.data.success
          ? setModal({
            show: true,
            title: translator("StoreUpdate-SuccesModal-Title"),
            text: translator("StoreUpdate-SuccesModal-Text"),
            btnClass: "btn btn-primary",
            success: true,
          })
          : setModal({
            show: true,
            title: translator("StoreUpdate-UnsuccesModal-Title"),
            text: translator("StoreUpdate-UnsuccesModal-Text"),
            btnClass: "btn btn-primary",
            success: false,
          });
      })
      .catch((err) =>
        setModal({
          show: true,
          title: translator("StoreUpdate-UnsuccesModal-Title"),
          text: translator("StoreUpdate-UnsuccesModal-Text"),
          btnClass: "btn btn-primary",
        })
      );
  };

  const handleCancel = () => {
    goBack();
  };

  return (
    <CardWrap subtitle={translator("StoreUpdate-Subtitle")}>
      {!isLoading && (
        <form onSubmit={handleSubmit(onSubmit)} className="row">
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("StoreUpdate-GeneralData")}
              </legend>
              <div className="form-group">
                <label> {translator("StoreUpdate-Description")}</label>{" "}
                <Tooltip text={translator("Store-Description-Msg")} />
                <textarea
                  id="textArea"
                  rows="2"
                  className="form-control"
                  name="description"
                  ref={register({ required: true, maxLength: 250 })}
                  defaultValue={store.description}
                />
                {errors.description &&
                  errors.description.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                {errors.description &&
                  errors.description.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength250")}
                    </p>
                  )}
              </div>
              <div className="form-group">
                <label htmlFor="tag">{translator("StoreUpdate-Tag")}</label>{" "}
                <Tooltip text={translator("Store-Tag-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="tag"
                  ref={
                    store.tag !== ""
                      ? register({
                        required: true,
                        pattern: storeTag,
                      })
                      : register({
                        pattern: storeTag,
                      })
                  }
                  defaultValue={store.tag}
                />
                {errors.tag && (
                  <>
                    {errors.tag.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                    {errors.tag.type === "pattern" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-StoreTag")}
                      </p>
                    )}
                  </>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="type">{translator("StoreUpdate-Type")}</label>
                <select
                  defaultValue={store.type}
                  name="type"
                  ref={register({ required: true })}
                  className="form-control"
                >
                  <option value="" disabled>
                    {translator("StoreUpdate-SelectOption-ChooseType")}
                  </option>
                  <option value="1">
                    {translator("StoreUpdate-SelectOption-Fixed")}
                  </option>
                  <option value="2">
                    {translator("StoreUpdate-SelectOption-Mobile")}
                  </option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="footerNote">
                  {translator("StoreUpdate-FooterText")}
                </label>{" "}
                <Tooltip text={translator("Store-FooterText-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="footerNote"
                  ref={register({ required: true, maxLength: 250 })}
                  defaultValue={store.footerNote}
                />
                {errors.footerNote && (
                  <>
                    {errors.footerNote.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                    {errors.footerNote.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength250")}
                      </p>
                    )}
                  </>
                )}
              </div>
            </fieldset>
          </div>
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("StoreUpdate-AdressData")}
              </legend>
              <div className="form-group">
                <label htmlFor="street">
                  {translator("StoreUpdate-Street")}
                </label>{" "}
                <Tooltip text={translator("Store-Street-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="street"
                  ref={register({
                    required: true,
                    maxLength: 150,
                    pattern: address,
                  })}
                  defaultValue={store.street}
                />
                {errors.street && (
                  <>
                    {errors.street.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}

                    {errors.street.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength150")}
                      </p>
                    )}
                  </>
                )}
              </div>
              <div className="form-row">
                <div className="form-group col-md-7">
                  <label htmlFor="streetNumber">
                    {translator("StoreUpdate-StreetNumber")}
                  </label>{" "}
                  <Tooltip text={translator("Store-StreetNumber-Msg")} />
                  <input
                    type="text"
                    className="form-control"
                    name="streetNumber"
                    ref={register({
                      required: true,
                      pattern: numbersOnly,
                      maxLength: 6,
                    })}
                    defaultValue={store.streetNumber}
                  />
                  {errors.streetNumber &&
                    errors.streetNumber.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  {errors.streetNumber &&
                    errors.streetNumber.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength6")}
                      </p>
                    )}
                  {errors.streetNumber &&
                    errors.streetNumber.type === "pattern" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-NumberOnly")}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-5">
                  <label htmlFor="streetNumberExtension">
                    {translator("StoreUpdate-StreetNumberAddition")}
                  </label>{" "}
                  <Tooltip
                    text={translator("Store-StreetNumberAdittion-Msg")}
                  />
                  <input
                    type="text"
                    className="form-control"
                    name="streetNumberExtension"
                    ref={register({ maxLength: 10 })}
                    defaultValue={store.streetNumberExtension}
                  />
                  {errors.streetNumberExtension && (
                    <>
                      {errors.streetNumberExtension.type === "maxLength" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-MaxLength10")}
                        </p>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-5">
                  <label htmlFor="streetNumberExtension">
                    {translator("StoreUpdate-ZipCode")}
                  </label>{" "}
                  <Tooltip text={translator("Store-ZipCode-Msg")} />
                  {postOffices.length != 0 && (
                    <Controller
                      as={Select}
                      options={
                        postOffices &&
                        postOffices.map((p) => ({
                          id: p.id,
                          label: p.name,
                          value: p.name,
                        }))
                      }
                      name="postalNumber"
                      defaultValue={{
                        label:
                          postOffices.length != 0 ? store.postalNumber : "",
                        value:
                          postOffices.length != 0 ? store.postalNumber : "",
                      }}
                      control={control}
                      onChange={function (event) {
                        getCity(event[0].id, event[0].label);
                        return event[0];
                      }}
                    />
                  )}
                </div>
                <div className="form-group col-md-7">
                  <label htmlFor="streetNumber">
                    {translator("StoreUpdate-City")}
                  </label>{" "}
                  <Tooltip text={translator("Store-City-Msg")} />
                  <input
                    type="text"
                    className="form-control"
                    name="city"
                    ref={register}
                    defaultValue={store.city}
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="countryId">
                  {translator("StoreUpdate-State")}
                </label>
                {countries.length > 0 && store.countryId !== "" && (
                  <select
                    className="form-control"
                    name="countryId"
                    ref={register({
                      validate: (value) => value !== "-1",
                    })}
                    defaultValue={store.countryId}
                  >
                    {countries &&
                      countries.map((c) => (
                        <option selected={true} value={c.id}>
                          {c.name}
                        </option>
                      ))}
                  </select>
                )}
              </div>
            </fieldset>
          </div>
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("Accounting")}
              </legend>
              <div className="form-group col-12">
                <label className="labelCont">
                  <input
                    type="checkbox"
                    name="useAccounting"
                    ref={register}
                    defaultChecked={store.useAccounting}
                  />
                  <span className="checkmark"></span>
                </label>
                <span>{translator("Onboarding-TenantData-IsAccounting")}</span>{" "}
              </div>
              <div className="form-group col-12">
                <label className="labelCont">
                  <input
                    type="checkbox"
                    name="useFinancial"
                    ref={register}
                    defaultChecked={store.useFinancial}
                  />
                  <span className="checkmark"></span>
                </label>
                <span>{translator("Onboarding-TenantData-IsFinancial")}</span>{" "}
              </div>
            </fieldset>
          </div>
          <div
            className="container-fluid"
            style={{
              display: "flex",
              paddingTop: "3%",
              justifyContent: "flex-end",
            }}
          >
            <button
              className="btn btn-outline-secondary"
              onClick={handleCancel}
            >
              {translator("Btn-Cancel")}
            </button>
            &nbsp;
            <button
              disabled={!formState.dirty}
              className="btn btn-primary"
              type="submit"
            >
              {translator("Btn-Save")}
            </button>
          </div>
        </form>
      )}
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />

      {isLoading && <SpinnerLoading />}
    </CardWrap>
  );
};

export default StoreUpdate;
